import React, { useRef, useState } from "react";
import { Card, Button, Select, Upload, Tag, message, Switch } from "antd";
import {
  UploadOutlined,
  DownloadOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Coins,
  Rocket,
  CheckCircle,
  Clock,
  ArrowRight,
  Sparkles,
} from "lucide-react";
import CategorySearch from "../Components/CategorySearch";
import {
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { toast } from "react-toastify";
import OptimizeProgress from "../Components/OptimizeProgress";
import reapi from "../apis/reapi";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";

const categories = [
  {
    "name": "Kurtis",
    "chain": [
      "Women Fashion",
      "Ethnic Wear",
      "Kurtis, Sets & Fabrics",
      "Kurtis"
    ],
    "category": "sub-sub-category",
    "id": 10004,
    "img": "👗"
  },
  {
    "name": "Blouses",
    "chain": [
      "Women Fashion",
      "Ethnic Wear",
      "Sarees, Blouses & Petticoats",
      "Blouses"
    ],
    "category": "sub-sub-category",
    "id": 11306,
    "img": "👚"
  },
  {
    "name": "Sarees",
    "chain": [
      "Women Fashion",
      "Ethnic Wear",
      "Sarees, Blouses & Petticoats",
      "Sarees"
    ],
    "category": "sub-sub-category",
    "id": 10003,
    "img": "🥻"
  },
  {
    "name": "Track Pants",
    "chain": [
      "Men Fashion",
      "Mens Clothing",
      "Men Bottom Wear",
      "Track Pants"
    ],
    "category": "sub-sub-category",
    "id": 10258,
    "img": "👖"
  },
  {
    "name": "Handbags",
    "chain": [
      "Bags, Luggage & Travel Accessories",
      "Women Bags",
      "Handbags"
    ],
    "category": "sub-category",
    "id": 1102,
    "img": "👜"
  },
  {
    "name": "Leggings",
    "chain": [
      "Women Fashion",
      "Western Wear",
      "Palazzos, Leggings & Tights",
      "Leggings"
    ],
    "category": "sub-sub-category",
    "id": 10155,
    "img": "🩳"
  },

];



export default function OptimizeImage() {
  const token = localStorage.getItem('token')

  const [screen, setScreen] = useState("form");


  const [selectedCategory, setSelectedCategory] = useState(null);

  const [fileList, setFileList] = useState([])

  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const fileInputRef = useRef();

  const [isOptimizing, setIsOptimizing] = useState(false);
  const [progress, setProgress] = useState(0);

  const [data, setdata] = useState(null)
  const [base64, setbase64] = useState('')

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

   const Toggle = ({ checked, onChange }) => (
        <div
            onClick={() => onChange(!checked)}
            style={{
                width: 48,
                height: 28,
                borderRadius: 20,
                background: checked ? "#ff5a1f" : "#ddd",
                position: "relative",
                cursor: "pointer",
                transition: "0.3s",
            }}
        >
            <div
                style={{
                    width: 22,
                    height: 22,
                    borderRadius: "50%",
                    background: "#fff",
                    position: "absolute",
                    top: 3,
                    left: checked ? 23 : 3,
                    transition: "0.3s",
                }}
            />
        </div>
    );

    const [removeBg, setRemoveBg] = useState(false);

   



  const handleOptimize = async () => {

    if (selectedCategory == null) {
      toast.error('Please Select category')

    } else {
      if (imageUrl == null) {
        toast.error('Please Select File')
      } else {

        const sizeInKB = selectedFile?.size / 1024;

        if (sizeInKB > 10500) {
          toast.error('Image size Below 10MB')
        } else {




          const base64 = await convertToBase64(selectedFile);
          // console.log(base64)
          setbase64(base64)

          const payload = {
            imageBase64: base64,
            categoryid: selectedCategory?.id,
            categoryname: selectedCategory?.name,
            removeBg
          }


          setScreen("optimizing");
          setProgress(0);
          setIsOptimizing(true);

          const interval = setInterval(() => {
            setProgress((prev) => {
              if (prev < 25) return prev + 1.25; // 20 sec
              if (prev < 50) return prev + 1.25; // 40 sec
              if (prev < 75) return prev + 1.25; // 60 sec
              if (prev < 95) return prev + 0.25; // slow till response
              return prev;
            });
          }, 1000);

          try {
            const response = await reapi.post("/imgoptimize", payload, {
              headers: {
                "Authorization": `Beaer ${token}`
              }
            });

            clearInterval(interval);


            console.log(response.data)




            setProgress(100);
            setTimeout(() => {
              setdata(response?.data?.data?.newHistory);
              setScreen("result");

              if (response?.data?.data?.newHistory?.savings >= 5) {
                message.success({
                  content: `🎉 You saved ₹${response?.data?.data?.newHistory?.savings}. 10 credits deducted.`,
                  duration: 5,
                });
              } else {
                message.warning({
                  content: `No credits deducted.`,
                  duration: 5,
                });
              }

              toast.success(response?.data?.message)
              localStorage.setItem('userInfo', JSON.stringify(response.data.data?.user));
              window.dispatchEvent(new Event("userUpdated"));

              setIsOptimizing(false);
            }, 1000);
          } catch (err) {
            clearInterval(interval);
            setIsOptimizing(false);
            setScreen("form");
            toast.error(err?.response?.data.message)
            // console.log(err)
          }
          // optimization logic
        }
      }
    }


  }

  const handleDownload = async () => {
    const imageUrl = data?.imgurl;

    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `shipless-optimized-${Date.now()}.jpg`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleOptimizeAnother = () => {
    setScreen("form");

    setProgress(0);
    setdata(null)

    setImageUrl(null);
    setSelectedFile(null);

    setSelectedCategory(null);

    setIsOptimizing(false);
  };








  return (

    <AnimatePresence mode="wait">
      <div className="w-full max-w-full overflow-x-hidden bg-[#f8f9ff] p-4 md:p-6 text-slate-900">
        <div className="w-full max-w-[1400px] mx-auto overflow-x-hidden">
          <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4 mb-5">
            <div>
              <h1 className="text-2xl md:text-3xl font-extrabold m-0">
                Optimize Image
              </h1>
              <p className="text-slate-600 mt-2">
                Upload product image, optimize it and reduce Meesho shipping charges.
              </p>
            </div>

            <div className="shrink-0 flex items-center gap-3 bg-purple-50 text-purple-700 px-5 py-3 rounded-xl font-semibold">
              <Coins size={20} />
              <span>Cost Per Optimization:</span>
              <span>10 Credits</span>
            </div>
          </div>

          <div className="grid grid-cols-1 2xl:grid-cols-[minmax(0,1fr)_360px] gap-6">
            <div className="min-w-0 space-y-14 ">

              {
                screen === "form" && (

                  // upload screen

                  <motion.div
                    key="form"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -15 }}
                    transition={{ duration: 0.35 }}
                  >
                    {/* Your upload/category screen */}

                    <Card className="rounded-2xl pb-6 shadow-sm">
                      <div className=" grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_48px_minmax(0,1fr)] gap-6">
                        <div className="min-w-0">
                          <h3 className="font-bold text-lg flex items-center gap-3">
                            <span className="w-8 h-8 shrink-0 rounded-full bg-purple-600 text-white flex items-center justify-center">
                              1
                            </span>
                            Select Category
                          </h3>

                          <p className="text-slate-600">Choose the product category</p>

                          {/* <Select
                    showSearch
                    defaultValue="Kurti"
                    className="w-full h-11 mb-5"
                    options={[
                      { value: "Kurti", label: "👗 Kurti" },
                      { value: "Blouse", label: "👚 Blouse" },
                      { value: "Saree", label: "🥻 Saree" },
                      { value: "Track Pant", label: "👖 Track Pant" },
                    ]}
                  /> */}

                          <CategorySearch
                            onSelectCategory={(category) => {
                              setSelectedCategory(category);
                            }}

                          />

                          {selectedCategory && (
                            <div className="m-4 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl px-4 py-3">
                              <div className="flex items-center gap-3">
                                <div className="text-xl">🎯</div>

                                <div>
                                  <div className="text-xs text-green-600 font-semibold">
                                    CATEGORY SELECTED
                                  </div>

                                  <div className="font-bold text-green-800">
                                    {selectedCategory?.name}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
                            {categories.map((vl, index) => (
                              <button
                                onClick={() => setSelectedCategory(vl)}
                                key={vl?.id}
                                className={`h-20 rounded-xl border flex flex-col items-center justify-center gap-1 transition ${vl?.id === selectedCategory?.id
                                  ? "border-purple-500 bg-purple-50 text-purple-700"
                                  : "border-transparent bg-slate-50 hover:border-purple-300"
                                  }`}
                              >
                                <span className="text-2xl">{vl.img}</span>
                                <span className="text-sm font-semibold">{vl.name}</span>
                              </button>
                            ))}

                           
                          </div>
                           <RemoveBackgroundCard removeBg={removeBg} setRemoveBg={setRemoveBg}/>
                        </div>

                        <div className="hidden xl:flex items-center justify-center">
                          <div className="w-11 h-11 rounded-full border bg-white flex items-center justify-center text-purple-600 shadow-sm">
                            <ArrowRight size={22} />
                          </div>
                        </div>


                        {imageUrl ? (
                          <div className="relative h-[220px] flex items-center justify-center p-3">
                            <img
                              src={imageUrl}
                              alt="preview"
                              className="max-h-full  max-w-full object-contain rounded-lg"
                            />

                            <div className="absolute top-3 right-3 flex gap-2">
                              <Button
                                shape="circle"
                                icon={<EditOutlined />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  fileInputRef.current?.click();
                                }}
                              />

                              <Button
                                danger
                                shape="circle"
                                icon={<DeleteOutlined />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setImageUrl(null);
                                  setSelectedFile(null);
                                }}
                              />
                            </div>

                            <input
                              ref={fileInputRef}
                              type="file"
                              accept="image/*"
                              className="hidden"
                              onChange={async (e) => {
                                const file = e.target.files?.[0];

                                if (!file) return;

                                setSelectedFile(file);
                                setImageUrl(URL.createObjectURL(file));

                              }}
                            />
                          </div>
                        ) : (

                          <div className="min-w-0  ">
                            <h3 className="font-bold  text-lg flex items-center gap-3">
                              <span className="w-8 h-8  shrink-0 rounded-full bg-purple-600 text-white flex items-center justify-center">
                                2
                              </span>
                              Upload Product Image
                            </h3>

                            <Upload.Dragger

                              beforeUpload={(file) => {
                                if (!selectedCategory) {
                                  toast.error('Please select category first')
                                  message.warning("Please select category first");
                                  return Upload.LIST_IGNORE;
                                }

                                setSelectedFile(file);
                                setImageUrl(URL.createObjectURL(file));

                                return false;
                              }}


                              // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                              accept={'image/*'}
                              multiple={false}
                              showUploadList={false}
                              maxCount={1}
                              fileList={fileList}
                              onChange={({ fileList: newFileList }) => setFileList(newFileList)}
                              className="!w-full  !bg-white !border-purple-300 !rounded-2xl"
                            >
                              <div className="py-8">
                                <UploadOutlined className="text-5xl text-purple-600" />
                                <p className="font-semibold mt-3">
                                  Drag & Drop your image here
                                </p>
                                <p className="text-slate-500">or</p>
                                <Button
                                  type="primary"
                                  size="large"
                                  className="bg-purple-600"
                                >
                                  Select Image
                                </Button >
                                <p className="text-slate-500 mt-3">
                                  JPG, PNG • Max 10MB
                                </p>
                              </div>
                            </Upload.Dragger>
                          </div>)}
                      </div>

                      <div className="border mt-16 border-purple-200 bg-purple-50 rounded-2xl p-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                        <div className="flex items-center gap-4 min-w-0">
                          <div className="w-12 h-12 shrink-0 rounded-full bg-white flex items-center justify-center text-purple-600">
                            <Rocket size={24} />
                          </div>
                          <p className="m-0 text-slate-700">
                            You are about to optimize this image for lowest shipping charges on Meesho.
                          </p>
                        </div>

                        <div className="flex flex-col sm:flex-row sm:items-center gap-4 shrink-0">
                          <span className="font-semibold">Credits Required: 🪙 10</span>
                          <Button
                            type="primary"
                            size="large"
                            icon={<Rocket size={18} />}
                            className="bg-purple-600 h-12 px-8 font-bold"
                            onClick={handleOptimize}
                          >
                            Optimize Image
                          </Button>
                        </div>
                      </div>
                    </Card>
                  </motion.div>
                )
              }





              {screen === "optimizing" && (
                <motion.div
                  key="optimizing"
                  initial={{ opacity: 0, y: 20, scale: 0.98 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -20, scale: 0.98 }}
                  transition={{ duration: 0.45 }}
                >
                  <OptimizeProgress
                    progress={progress}
                    imageUrl={imageUrl}
                    categoryName={selectedCategory?.name}
                    credits={10}
                  />
                </motion.div>
              )}



              {screen === "result" && (
                <motion.div
                  key="result"
                  initial={{ opacity: 0, y: 20, scale: 0.98 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -20, scale: 0.98 }}
                  transition={{ duration: 0.45 }}
                >
                  {/* Optimization Result Card */}
                  <Card className="rounded-2xl shadow-sm">
                    <div className="flex items-start gap-3 mb-5">
                      <CheckCircle size={40} className="text-green-600 shrink-0" />
                      <div>
                        <h3 className="font-bold text-3xl m-0">
                          Optimization Result
                        </h3>
                        <p className="text-slate-600 m-0">
                          We found the best optimized image for lowest shipping charges.
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_50px_minmax(0,1fr)_320px] gap-6 items-center">
                      <ImageBox
                        title="Original Image"
                        // sizeText="Original Size: 1.24 MB"
                        img={imageUrl}
                      />

                      <div className="hidden xl:flex justify-center items-center text-purple-600 text-3xl">
                        →
                      </div>

                      <ImageBox
                        title="Optimized Image"
                        // sizeText={
                        //   <>
                        //     Optimized Size: <b>210 KB</b>{" "}
                        //     <span className="text-green-600"></span>
                        //   </>
                        // }
                        img={data?.imgurl}
                        optimized
                      />

                      <div className="border rounded-2xl p-5 min-w-0">
                        <h4 className="font-bold mb-6">
                          Shipping Charge Comparison
                        </h4>

                        <div className="flex justify-between gap-4 py-4 border-b">
                          <span>Original Shipping Charge</span>
                          <b className="text-red-600 shrink-0">₹{data?.originalshipping}.00</b>
                        </div>

                        <div className="flex justify-between gap-4 py-4 border-b">
                          <span>Optimized Shipping Charge</span>
                          <b className="text-green-600 shrink-0">₹{data?.optimizedshipping}.00</b>
                        </div>

                        <div className="flex justify-between items-center gap-4 mt-5 bg-green-50 border border-green-200 rounded-xl p-4">
                          <b>Total Savings</b>
                          <strong className="text-xl md:text-2xl text-green-600">
                            ₹{data?.savings}.00
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-4 mt-6">
                      <Stat icon={<Coins />} label="Credits Used" value={`${data?.credits} Credits`} />
                      <Stat icon={<Clock />} label="Processing Time" value={`${data?.timetake} sec`} />
                      <Stat
                        icon={<CheckCircle />}
                        label="Variations Checked"
                        value={data?.variationsChecked}
                      />

                      <div className="w-full xl:w-auto xl:ml-auto flex flex-col sm:flex-col gap-3">
                        <Button onClick={handleOptimizeAnother} size="large" icon={<SyncOutlined />}>
                          Optimize Another
                        </Button>

                        <Button
                          type="primary"
                          size="large"
                          icon={<DownloadOutlined />}
                          className="bg-purple-600"
                          onClick={handleDownload}
                        >
                          Download Optimized Image
                        </Button>
                      </div>
                    </div>
                  </Card>
                </motion.div>
              )}



            </div>

            <aside className="min-w-0 space-y-5">
              {/* <Card className="rounded-2xl shadow-sm">
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-lg m-0">Optimization History</h3>
                <button className="text-purple-600 font-semibold">View All</button>
              </div>

              <div className="space-y-4">
                {history.map(([title, date, save, icon]) => (
                  <div
                    key={title}
                    className="flex items-center gap-4 border-b pb-4 last:border-b-0"
                  >
                    <div className="w-14 h-14 shrink-0 rounded-lg bg-slate-100 flex items-center justify-center text-2xl">
                      {icon}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="m-0 font-bold truncate">{title}</h4>
                      <p className="m-0 text-slate-500 text-sm truncate">
                        {date}
                      </p>
                    </div>
                    <div className="text-right shrink-0">
                      <Tag color="green">Saved {save}</Tag>
                      <p className="text-sm text-slate-500 m-0">15 Credits</p>
                    </div>
                  </div>
                ))}
              </div>
            </Card> */}


            </aside>

            <Card className="rounded-2xl shadow-sm">
              <h3 className="font-bold text-lg">How it works?</h3>

              {[
                ["Upload Image", "Upload your product image"],
                ["We Optimize", "We check multiple variations"],
                ["Lowest Shipping", "Get the image with lowest shipping"],
                ["You Save More", "Save money on every order"],
              ].map(([title, desc], i) => (
                <div key={title} className="flex gap-4 mb-5">
                  <div className="w-12 h-12 shrink-0 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center font-bold">
                    {i + 1}
                  </div>
                  <div className="min-w-0">
                    <h4 className="m-0 font-bold">{title}</h4>
                    <p className="m-0 text-slate-500">{desc}</p>
                  </div>
                </div>
              ))}

              <div className="bg-purple-50 rounded-2xl p-5 flex gap-4">
                <Sparkles className="text-purple-600 shrink-0" />
                <p className="m-0 text-slate-700">
                  Optimize and save more on every Meesho order.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </AnimatePresence>
  );
}

function ImageBox({ title, sizeText, optimized, img }) {

  return (



    <div className="min-w-0">
      <h4 className="font-bold text-center mb-3">{title}</h4>

      <div className="relative h-[260px] rounded-2xl bg-slate-100 flex items-center justify-center">
        {optimized && (
          <span className="absolute top-3 right-3 bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold">
            Optimized
          </span>
        )}

        <img
          src={img}
          alt="preview"
          className="max-h-full  max-w-full object-contain rounded-lg p-2"
        />
      </div>

      <p className="text-center mt-3 text-slate-600">{sizeText}</p>
    </div>
  );
}

function Stat({ icon, label, value }) {
  return (
    <div className="border rounded-xl p-4 flex items-center gap-3 min-w-[160px]">
      <div className="text-purple-600 shrink-0">{icon}</div>
      <div>
        <b>{value}</b>
        <p className="m-0 text-xs text-slate-500">{label}</p>
      </div>
    </div>
  );
}




function RemoveBackgroundCard({ removeBg, setRemoveBg }) {
  return (
    <div
      className={`mt-6 rounded-2xl border p-5 transition ${
        removeBg
          ? "bg-purple-50 border-purple-300 shadow-sm"
          : "bg-white border-slate-200"
      }`}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-xl bg-purple-100 text-purple-600 flex items-center justify-center shrink-0">
            <Sparkles size={18} />
          </div>

          <div>
            <div className="flex items-center gap-1">
              <h3 className="text-md font-bold m-0">Remove Background</h3>
               {/* <span className="bg-purple-600 text-white text-sm px-2 py-1 rounded-full font-bold">
                Recommended
              </span> */}

            
            </div>

            <p className="text-slate-500 m-0 mt-1 text-xs">
             Get a clean white background
            </p>
{/* 
            <div className="flex flex-wrap gap-3 mt-4">
              <span className="inline-flex  items-center gap-2 bg-white border border-purple-100 text-purple-700 px-3  rounded-xl text-xs font-semibold">
                <CheckCircle size={10} />
                Clean & Professional
              </span>

              <span className="inline-flex items-center gap-2 bg-white border border-purple-100 text-purple-700 px-3  rounded-xl text-xs font-semibold">
                <CheckCircle size={10} />
                Better Visibility
              </span>
            </div> */}
          </div>
        </div>

        <Switch
          checked={removeBg}
          onChange={setRemoveBg}
          className="scale-100"
        />
      </div>
    </div>
  );
}

